/* =====================================================================
   Joy Diffusion Perfumes — scoped JS.
   Only runs on pages with the `jd-site` body class.
   Handles: JD burger menu, PDP size-selector → variant mapping,
   add-to-cart via /cart/add.js, collage-poster lightbox (simple).
   ===================================================================== */

(function () {
  'use strict';

  var body = document.body;
  if (!body.classList.contains('jd-site')) return;

  /* ---- JD burger (mobile) ---- */
  var burger = document.querySelector('[data-jd-burger]');
  var nav = document.querySelector('.jd-nav');
  if (burger && nav) {
    burger.addEventListener('click', function () {
      var open = nav.style.display === 'flex';
      nav.style.display = open ? '' : 'flex';
      nav.style.flexDirection = open ? '' : 'column';
      nav.style.position = open ? '' : 'absolute';
      nav.style.top = open ? '' : '100%';
      nav.style.left = open ? '' : '0';
      nav.style.right = open ? '' : '0';
      nav.style.background = open ? '' : '#fff';
      nav.style.padding = open ? '' : '16px';
      nav.style.border = open ? '' : '3px solid #111';
      nav.style.borderTop = open ? '' : 'none';
      nav.style.zIndex = open ? '' : '50';
    });
  }

  /* ---- PDP: size selector → variant ---- */
  var sizeOpts = document.querySelectorAll('.jd-size-opt');
  var variantInput = document.getElementById('jd-pdp-variant-input');
  var priceEl = document.getElementById('jd-pdp-price');
  var sizeLabel = document.getElementById('jd-pdp-size-label');
  var atcBtn = document.getElementById('jd-pdp-atc');

  if (sizeOpts.length && variantInput) {
    sizeOpts.forEach(function (opt) {
      opt.addEventListener('click', function () {
        sizeOpts.forEach(function (o) { o.classList.remove('sel'); });
        opt.classList.add('sel');
        variantInput.value = opt.dataset.variantId;
        if (priceEl && opt.dataset.price) {
          priceEl.querySelector('strong').textContent = opt.dataset.price;
        }
        if (sizeLabel) sizeLabel.textContent = '· ' + opt.dataset.title;
        if (atcBtn) atcBtn.disabled = opt.dataset.available === 'false';
      });
    });
  }

  /* ---- PDP: add to cart via /cart/add.js ---- */
  var form = document.getElementById('jd-pdp-form');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var id = variantInput ? variantInput.value : null;
      if (!id) return;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(id, 10), quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          window.location.href = '/cart';
        })
        .catch(function () {
          form.submit(); // fallback to normal form post
        });
    });
  }

  /* ---- Lineup: Add buttons (quick add) ---- */
  document.querySelectorAll('.jd-add[data-variant-id]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(btn.dataset.variantId, 10), quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          window.location.href = '/cart';
        });
    });
  });

  /* ---- PDP: thumbnails swap main image ---- */
  var mainImg = document.getElementById('jd-pdp-main-img');
  document.querySelectorAll('.jd-pdp-thumbs img').forEach(function (t) {
    t.addEventListener('click', function () {
      document.querySelectorAll('.jd-pdp-thumbs img').forEach(function (o) { o.classList.remove('on'); });
      t.classList.add('on');
      if (mainImg && t.dataset.full) mainImg.src = t.dataset.full;
    });
  });

  /* ---- PDP: accordions (simple expand/collapse) ---- */
  document.querySelectorAll('.jd-pdp-accord[data-accord]').forEach(function (acc) {
    acc.addEventListener('click', function () {
      var next = acc.nextElementSibling;
      if (next && next.classList.contains('jd-accord-body')) {
        next.style.display = next.style.display === 'block' ? '' : 'block';
      }
    });
  });
})();
